import { BagUpsellRail, BagUpsellProductOption } from './components';

export const BagUpsell = {
  Rail: BagUpsellRail,
  ProductOption: BagUpsellProductOption,
};
